import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import TimeSlots from '../TimeSlots/TimeSlotsContainer.js';
import Loading from './AppointmentPickDifferentTimeSlotLoading.js';
import NotAvailable from './AppointmentPickDifferentTimeSlotNotAvailable.js';

const AppointmentPickDifferentTimeSlotContent = ({ labels , loading , timeSlots , onSelectTimeSlot , selected , onClickPrevious  })=>{
    if (loading) {
        return /*#__PURE__*/ React.createElement(Loading, {
            labels: labels
        });
    }
    if (timeSlots.length === 0) {
        return /*#__PURE__*/ React.createElement(NotAvailable, {
            labels: labels,
            onClickPrevious: onClickPrevious
        });
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h3", null, labels.selectATime), /*#__PURE__*/ React.createElement(Text, {
        color: "text-secondary"
    }, labels.selectATimeSubtitle), /*#__PURE__*/ React.createElement(TimeSlots, {
        className: "appointment-pick-different-time-slot__slots",
        loading: loading,
        slots: timeSlots,
        onSelectTime: onSelectTimeSlot,
        selected: selected !== null && selected !== void 0 ? selected : undefined
    }), /*#__PURE__*/ React.createElement("button", {
        className: "appointment-pick-different-time-slot__previous",
        onClick: onClickPrevious,
        type: "button"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "link",
        className: "appointment-pick-different-time-slot__link"
    }, labels.selectAnotherDay)));
};
var AppointmentPickDifferentTimeSlotContent$1 = AppointmentPickDifferentTimeSlotContent;

export { AppointmentPickDifferentTimeSlotContent$1 as default };
//# sourceMappingURL=AppointmentPickDifferentTimeSlotContent.js.map
